import { render } from "./MeldingEditView.vue?vue&type=template&id=15dc2a81&scoped=true"
import script from "./MeldingEditView.vue?vue&type=script&lang=js"
export * from "./MeldingEditView.vue?vue&type=script&lang=js"

import "./MeldingEditView.vue?vue&type=style&index=0&id=15dc2a81&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15dc2a81"]])

export default __exports__